import * as React from 'react';

var _path;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgUnknown = function SvgUnknown(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "currentColor",
        viewBox: "0 0 64 64"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        d: "M32 59c14.912 0 27-12.088 27-27S46.912 5 32 5 5 17.088 5 32s12.088 27 27 27m0 5c17.673 0 32-14.327 32-32S49.673 0 32 0 0 14.327 0 32s14.327 32 32 32m0-12c11.046 0 20-8.954 20-20s-8.954-20-20-20-20 8.954-20 20 8.954 20 20 20m0 3c12.702 0 23-10.298 23-23S44.702 9 32 9 9 19.297 9 32s10.297 23 23 23m.055-35.6c-.87 0-1.576.705-1.576 1.576v1.575q0 .067.005.13c-4.474.748-7.884 4.639-7.884 9.325 0 4.687 3.41 8.577 7.884 9.325a2 2 0 0 0-.005.13v1.576a1.576 1.576 0 1 0 3.152 0V41.46q0-.066-.006-.13a9.45 9.45 0 0 0 5.975-3.626 6.3 6.3 0 0 1-2.424-2.023 6.303 6.303 0 1 1 0-7.35 6.3 6.3 0 0 1 2.424-2.024 9.45 9.45 0 0 0-5.975-3.627q.006-.064.006-.13v-1.575c0-.87-.706-1.576-1.576-1.576"
    })));
};

export { SvgUnknown as ReactComponent };
//# sourceMappingURL=Unknown.svg.es.js.map
